(ns bp-libs.design-system.components.thumb
  "Namespace for thumbnails"
  (:require [bp-libs.design-system.components.icons :as icons]
            [bp-libs.design-system.components.progress :refer [continue-watching-bar]]
            [bp-libs.design-system.helpers :refer [event-callback]]))

(defn thumb
  {:storybook {:on-click            {:action "OnClick"}
               :on-focus            {:action "OnFocus"}
               :on-image-failed     {:action "OnImageFailed"}
               :container           {:name         "Container Config"
                                     :type         {:name "object"}
                                     :defaultValue {:height "60vh" :width "40vw", :aspect-ratio nil}
                                     :control      {:type "object"}}
               :image-url           {:name         "Image Url"
                                     :type         {:name "string" :required true}
                                     :defaultValue "https://picsum.photos/340/300"
                                     :control      {:type "text"}}
               :original?           {:name         "Original"
                                     :type         {:name "boolean"}
                                     :defaultValue false
                                     :control      {:type "boolean"}}
               :image-position      {:name         "Image Position"
                                     :type         {:name "string"}
                                     :defaultValue "center"
                                     :control      {:type "select" :options ["top" "center"]}}
               :image-fit           {:name         "Image Fit"
                                     :type         {:name "string"}
                                     :defaultValue "cover"
                                     :control      {:type "select"} :options ["fill" "cover"]}
               :inset-text?         {:name         "Text Inset"
                                     :type         {:name "boolean"}
                                     :defaultValue false
                                     :control      {:type "boolean"}}
               :image-filter?       {:name         "Image Filter"
                                     :type         {:name "boolean"}
                                     :defaultValue true
                                     :control      {:type "boolean"}}
               :image-filter-position           {:name         "Image Filter Position"
                                                 :type         {:name "string"}
                                                 :defaultValue "bottom"
                                                 :control      {:type "select"} :options ["left" "bottom"]}
               :show-play-icon?     {:name         "Show Play Icon"
                                     :type         {:name "boolean"}
                                     :defaultValue true
                                     :control      {:type "boolean"}}
               :show-lock-icon?     {:name         "Show Lock Icon"
                                     :type         {:name "boolean"}
                                     :defaultValue false
                                     :control      {:type "boolean"}}
               :show-opened-lock-icon? {:name         "Show Opened Lock Icon"
                                        :type         {:name "boolean"}
                                        :defaultValue false
                                        :control      {:type "boolean"}}
               :subtitle            {:name         "Subtitle"
                                     :type         {:name "string"}
                                     :defaultValue nil
                                     :control      {:type "text"}}
               :bottom-subtitle     {:name         "Bottom subtitle"
                                     :type         {:name "string"}
                                     :defaultValue nil
                                     :control      {:type "text"}}
               :title               {:name         "Media Title"
                                     :type         {:name "string"}
                                     :defaultValue "T2:E3 Os Estados Unidos são uma democracia?"
                                     :control      {:type "text"}}
               :missing-image-title {:name         "Missing Image Title"
                                     :type         {:name "string"}
                                     :defaultValue "Title Showed When Image Fails to Load"
                                     :control      {:type "text"}}
               :duration            {:name         "Duration"
                                     :type         {:name "string"}
                                     :defaultValue "6h 30m"
                                     :control      {:type "text"}}
               :watch-progress      {:name         "Progress"
                                     :type         {:name "number"}
                                     :defaultValue 10
                                     :control      {:type "number"}}
               :playlist-count      {:name         "Playlist Count"
                                     :type         {:name "number"}
                                     :defaultValue 10
                                     :control      {:type "number"}}}}
  [{:keys [title subtitle bottom-subtitle duration image-url playlist-count original? missing-image-title-position-center?
           inset-text? image-filter? show-play-icon? show-lock-icon? show-opened-lock-icon?
           watch-progress container square-border? on-image-load dark-background? class img-class
           tab-index on-click on-focus on-image-failed hide-image? missing-image-title image-fit image-position image-filter-position full-image?]}]
  (let [duration?              (boolean (seq duration))
        playlist?              (and playlist-count (pos? playlist-count))
        title?                 (boolean (seq title))
        missing-title?         (boolean (seq missing-image-title))
        subtitle?              (boolean (seq subtitle))
        bottom-subtitle?       (boolean (seq bottom-subtitle))
        extra-info?            (or duration? playlist? subtitle?)
        title-info?            (or title? subtitle?)
        show-progress?         (and watch-progress (pos? watch-progress))
        image-overlays?        (or show-progress? show-play-icon? duration?)
        _top-overlays?         (or show-lock-icon? show-opened-lock-icon? original?)
        bottom-section?        (or extra-info? title-info?)
        {:keys [width height aspect-ratio]} (or container {})
        aspect-ratio-classes   (case (:w aspect-ratio)
                                 "16" "aspect-w-16 aspect-h-9"
                                 "11" "aspect-w-11 aspect-h-16"
                                 "")
        rounded-thumb-class    (cond
                                 square-border?  ""
                                 bottom-section? "rounded-t-lg"
                                 :else           "rounded-lg")]
    [:div {:class    ["relative cursor-pointer flex flex-col h-full place-content-start"
                      "rounded-lg outline-none"
                      class
                      (when (and tab-index (> tab-index 0)) "focusable-thumb")
                      (when-not square-border? "rounded-lg")
                      (when (or bottom-section? dark-background?) "dark-linear-gradient")]
           :style    {:width (if aspect-ratio "100%" width)}
           :tab-index tab-index
           :on-focus on-focus
           :on-click on-click}
     [:div {:class "text-black p-2 absolute top-0 w-full z-[1]"}
      [:div {:class ["flex w-full justify-between items-center"]}
       (cond
         show-lock-icon?
         [:div {:class ["z-[1] bg-white rounded-full p-1"]}
          [icons/lock {:width "1rem" :height "1rem"}]]

         show-opened-lock-icon?
         [:div {:class ["z-[1] bg-primary-600 text-gray-50 rounded-full p-1"]}
          [icons/opened-lock {:width "1rem" :height "1rem"}]])]]

     [:div {:class ["w-full h-full relative"
                    (when image-filter?
                      (cond
                        (= image-filter-position "left") "image-gradient-left"
                        (and (not square-border?) (not bottom-section?)) "image-radius-gradient image-gradient"
                        :else "image-gradient"))]}
      [:div {:class [(if aspect-ratio
                       aspect-ratio-classes
                       "w-full")]
             :style {:height height}}
       (if hide-image?
         (when missing-title?
           [:div {:class ["flex h-full py-4 text-white"
                          (when-not missing-image-title-position-center? "text-5xl text-left")
                          (when missing-image-title-position-center? "items-center place-content-center text-3xl text-center")]}
            missing-image-title])
         [:picture
          [:img {:src      image-url
                 :loading  "lazy"
                 :on-load  (when on-image-load #(on-image-load (event-callback {:url image-url})))
                 :on-error (when on-image-failed #(on-image-failed (event-callback {:url image-url})))
                 :class    [(if (= image-fit "fill") "object-fill" "object-cover")
                            (if (= image-position "top") "object-right-top" "object-right")
                            "h-full"
                            (when (or aspect-ratio full-image?) "w-full")
                            rounded-thumb-class
                            img-class]}]])]
      (when image-overlays?
        [:div {:class "text-black space-y-1 absolute bottom-0 w-full z-[1]"}
         [:div {:class "flex p-2 w-full justify-between items-center"}
          (when show-play-icon? [:div [icons/play]])
          (when duration? [:div {:class ["bg-gray-800 opacity-80 rounded-full"
                                         "p-2"
                                         "text-gray-50 font-semibold font-lg"]} duration])]
         (when show-progress? [continue-watching-bar {:width watch-progress}])])]
     (when bottom-section?
       [:div {:class ["text-xl font-normal space-y-1 text-gray-400 mix-blend-plus-lighter z-[1] h-full"
                      (if inset-text? "absolute bottom-0" "relative")]}
        [:div {:class ["p-4"]}
         (when subtitle? [:p {:class "pt-2"} subtitle])
         (when title? [:p {:class "text-gray-50 font-normal"} title])
         (when bottom-subtitle? [:p {:class "pt-2"} bottom-subtitle])
         (when extra-info?
           [:p {:class "space-x-3 flex place-items-center text-gray-400"}
            (when playlist? [:span {:class "inline-flex place-items-center"} [icons/youtube] [:span {:class "pl-1"} playlist-count]])])]])]))
